// extracted by mini-css-extract-plugin
export default {"block":"fq","flex":"gq","radio":"hq","label":"iq","error":"jq","extra":"kq"};